import React from "react";
import ClassicoShorts from "../Garments/ClassicoShorts";

export default function ClassicoShortsPage() {
  return <ClassicoShorts />;
}
